import './Preloader.scss';

export const Preloader = () => <span className="preloader"></span>;
